import React, { useState, useEffect } from 'react';
import Menu from "@mui/material/Menu";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";
import { socket } from "src/socket";
import Moment from 'react-moment';
import moment from 'moment';
import { useSelector } from "react-redux";

//Services
import { getUserId } from "src/Api/services/storageService";
import { getNotificationsPending } from 'src/Api/services/notificationService';
import { notificationTypes } from 'src/Data/notificationType';


function NotificationsPopup(props) {

    const {
        show,
        setShow,
        setPending
    } = props;

    const session = useSelector((state) => state.session);
    const userId = session?.user?.id || getUserId();
    const [loading, setLoading] = useState(true);
    const [notifications, setNotifications] = useState([]);

    const fetchData = async () => {
        if (!userId) return;
        let filter = {
            direction: 'desc',
        }
        await getNotificationsPending(userId, filter)
            .then((resp) => {
                const notificationsFilter = resp.data.notifications.filter(notification => notification?.type !== 'NEW_MESSAGE');
                setNotifications(notificationsFilter);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log("Error", err);
            })
    }

    useEffect(() => {
        fetchData();
        Object.keys(notificationTypes).forEach(type => {
            if (session?.userType === 'coach' && type != 'NEW_SESSION_FROM_COACH' || session?.userType === 'client' && type != 'NEW_SESSION_FROM_CLIENT') {
                socket.on(type, (body) => {
                    setNotifications(state => [...state, body]);
                });
            }
        });
        return () => {
            Object.keys(notificationTypes).forEach(type => {
                socket.off(type);
            });
        };
    }, []);

    useEffect(() => {
        if (notifications.length > 0)
            setPending(true);
    }, [notifications]);

    return (
        <Menu
            id="basic-menu"
            anchorEl={show}
            open={Boolean(show)}
            onClose={() => {
                setShow(null);
            }}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            PaperProps={{
                style: {
                    maxHeight: 300,
                    height: 300,
                    width: 270,
                    maxWidth: 270
                },
            }}
        >
            <div className='w-full'>
                <div className='w-full h-56 h-56 mt-2 px-4 overflow-y-auto'>
                    {notifications.length > 0 ? (
                        notifications.map(notification =>
                            <div className='flex border-b border-solid border-gray py-2'>
                                <div className='mx-2'>
                                    <img
                                        src={notificationTypes[notification?.type].icon}
                                        alt=""
                                        className="w-9 h-auto"
                                    />
                                </div>
                                <div>
                                    <p className='text-sm text-medium'>
                                        {notificationTypes[notification?.type].title}
                                    </p>

                                    <p className='text-sm text-light'>
                                        {notification?.type === 'CLIENT_INVITATION_ACEPTED' &&
                                            notification?.body.name + ' ' + notification?.body.lastName
                                        }
                                        {notification?.type === 'MEMBER_INVITATION_ACEPTED' &&
                                            notification?.body.name + ' ' + notification?.body.lastName
                                        }
                                        {notification?.type === 'NEW_SESSION_FROM_CLIENT' &&
                                            notification?.body.client.name + ' ' + notification?.body.client.lastName
                                        }
                                        {notification?.type==='NEW_SESSION_FROM_COACH'&&
                                            'Coach '+notification?.body.coach.name+' '+notification?.body.coach.lastName
                                        }
                                        {notification?.type === 'ASSIGNMENT_RESOURCE' &&
                                            notification?.body.title
                                        }
                                        {notification?.type === 'CANCELLED_SESSION_FROM_CLIENT' &&
                                            notification?.body.client.name + ' ' + notification?.body.client.lastName
                                        }
                                        {notification?.type === 'CANCELLED_SESSION_FROM_COACH' &&
                                            'Coach '+notification?.body.coach.name+' '+notification?.body.coach.lastName
                                        }
                                        {notification?.type === 'DAY_MEMORANDUM' &&
                                            'Coach '+notification?.body.description.slice(0,15)+'...'
                                        }
                                    </p>
                                    <p className='text-sm text-medium text-zinc'>
                                        {moment(notification?.createdAt).isSame(new Date(), 'day') ? (
                                            'HOY'
                                        ) : (
                                            <Moment format="D [de] MMMM" locale="es">
                                                {notification?.createdAt}
                                            </Moment>
                                        )}
                                    </p>
                                    <Link to={() => {
                                        switch (notification?.type) {
                                            case 'CLIENT_INVITATION_ACEPTED':
                                                return '/clients/view/' + notification?.body?.client;
                                                break;
                                            case 'MEMBER_INVITATION_ACEPTED':
                                                return '/groups/view/' + notification?.body?.group;
                                                break;
                                            case 'NEW_SESSION_FROM_CLIENT':
                                                return '/sessions/'+notification?.body?.client.id+'/Client';
                                                break;
                                            case 'ASSIGNMENT_RESOURCE':
                                                return '/resource/view/' + notification?.body?.resourceId;
                                                break;
                                            case 'CANCELLED_SESSION_FROM_CLIENT':
                                                return '/sessions/'+notification?.body?.client.id+'/Client';
                                                break;
                                            case 'CANCELLED_SESSION_FROM_COACH':
                                                return '/sessions/'+notification?.body?.client.id+'/Client';
                                                break;
                                            case 'DAY_MEMORANDUM':
                                                    return '/memorandums';
                                                break;
                                            default:
                                                return '/dashboard'
                                                break;
                                        }
                                    }}>
                                        <button class="text-sm text-regular text-white bg-green hover:bg-hover py-1 my-1 rounded-lg w-24">
                                            {notificationTypes[notification?.type].btn_text}
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        )

                    ) : (
                        <div className='text-base text-medium text-zinc text-center my-4 w-full'>
                            Sin Notificaciones
                        </div>
                    )}
                </div>
                <Divider
                    sx={{
                        bgcolor: "#fff"
                    }}
                />
                <div className='bg-white text-center'>
                    <Link to="/notifications">
                        <p className='text-base text-medium text-blue text-center pt-3'>
                            Ver todas las Notificaciones
                        </p>
                    </Link>
                </div>

            </div>
        </Menu>
    );
}

export default NotificationsPopup;
